import { BackgroundInfoJurisdiction } from './../background-info-jurisdiction';
import { BackgroundInfoType } from './../enums/background-info-type';

export class CopyBackgroundInfoModalPayload {
  destinationObjectId: number;
  destinationObjectIdentifier: string;
  useCase: BackgroundInfoType;
  jurisdiction: BackgroundInfoJurisdiction;
}
